<div class="textareas">
  <div class="textarea">
    <ng-content select="[header-input]" />
    <textarea #inputElement wrap="off" [placeholder]="inputPlaceholder()" (input)="inputToOutput(inputElement.value)"></textarea>
  </div>
  <div class="textarea">
    <ng-content select="[header-output]" />
    <textarea readonly wrap="off" [value]="outputStr | async"></textarea>
  </div>
</div>